import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useParams, useHistory, Link } from 'react-router-dom';
import themes from 'theme';
import LogoSVG from 'assets/images/svg/LogoGridUISVG';
import HelpSVG from 'assets/images/svg/HelpSVG';
import Search from 'components/search';
import MenuBase from 'components/menus/Base';
import DropdownMenu from 'components/menus/DropdownMenu';
import LinearProgress from 'components/progress/LinearProgress';
import UserMenu from './UserMenu';
import NotificationCenter from './notificationCenter';
import PropTypes from 'prop-types';
import BreadCrumbs from './BreadCrumbs';
import ChatSVG from 'assets/images/svg/ChatSVG';
import GridIcon from 'grids/GridIcon';
import { Paper } from '@material-ui/core';
import Avatar from 'components/avatar/Base';
import { HEADER_HEIGHT, RECORD_IDENTIFIER_TYPE, USER_SETTINGS } from 'const';
import HambergerMenuSVG from 'assets/images/svg/HambergerMenuSVG';
import AddonSVG from 'assets/images/svg/AddonSVG';
import AddonList from 'addons';
import { useDatabaseByDbId } from 'hooks/database';
import { useSelectedWorkspace } from 'hooks/workspace';
import {
    useViewImportLoading,
    useIsFilteringSorting,
    useIsFetchingDisabledColumnData,
    useGridUIIsLoading,
    useAllUploadingFileCount
} from 'hooks/gridUI';
import { useGridsByDbId, useGridDetail } from 'hooks/grid';
import { ENV } from 'config';
import { STAGING, DEVELOPMENT, INTEGRATION } from 'config/env';
import { useCurrentUserFullInfo, useAddonOpen, useTrialBackViewTime } from 'hooks/auth';
import * as authActions from 'auth/actions';
import { useDispatch } from 'react-redux';
import AccessControl from 'auth/AccessControl';
import * as roleConst from 'auth/roleConst';
import { useBranchesOptions } from 'hooks/versionControl/branch';
import ListItem from 'components/list/Item';
import ColorAddSVG from 'assets/images/svg/ColorAddSVG';
import UpgradeSVG from 'assets/images/svg/payment/UpgradeSVG';
import CreateGridBranchForm from 'versionControl/CreateGridBranchForm';
import { getAvatarUrl } from 'utils/images';
import { POPUP_PADDING_TOP_BOTTOM } from 'const/style';
import * as gridUIActions from 'gridUI/actions';
import { useCanVersionControl, useIsProTrial } from 'hooks/payment';
import LimitPopup from 'payment/components/popups/LimitPopup';
import {
    useIsOpenFeedback,
    useIsShowTemplates,
    useIsRetrialPeriod,
    useJiraCreateTypeOptions,
    useIsShowToggleKeyboardShortCut
} from 'hooks/app';
import FeedbackForm from 'feedback/Form';
import * as appActions from 'app/actions';
import { useInAppAddonVersion } from 'hooks/addons';
import CommentsSVG from 'assets/images/svg/CommentsSVG';
import PopperMenu from 'components/menus/Popper';
import HelpMenuPopup from './HelpMenuPopup';
import GridlyKeyBoard from './keyboard';
import useClickAwaitListener from 'hooks/useClickAwaitListener';
import ConfirmBox from 'components/confirmBox/Base';
import { useTranslation } from 'react-i18next';
import Dialog from 'components/dialog/Dialog';
import Tooltip from 'components/tooltip/Base';
import PreloadImages from 'components/preload/Image';
import AddonBanner from 'assets/images/svg/addon/AddonBanner.jpg';
import { SHOW_GRID_TYPES } from 'const/gridUI';
import Templates from 'template/grid';
import ChooseWorkspaceDatabase from './ChooseWorkspaceDatabase';
import SearchGlobalBox from 'search';
import TemplatesHeaderItem from './TemplatesHeaderItem';
import UniquePathtagRecordIdSVG from 'assets/images/svg/UniquePathtagRecordIdSVG';
import { checkContainId } from 'utils/clickAway';
import FreeTrialBack from '../workspaces/FreeTrialBack';
import * as gridActions from 'grids/actions';
import WhatNewDrawer from './WhatNewDrawer';
import WhatNewDialog from 'WhatNewDialog';
import EggSearchGif from 'assets/images/egg_search.gif';
import { sendManualTrack } from 'tracker';
import * as paymentActions from 'payment/actions';
import { useRole } from 'hooks/auth/role';
import OverflowItem from 'components/textTruncated/OverflowItem';
import { isExternal } from 'config';
import GlobalUniqueRecordIdSVG from 'assets/images/svg/GlobalUniqueRecordIdSVG';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
    root: {
        paddingLeft: 14,
        paddingRight: 14,
        borderRadius: 0,
        height: HEADER_HEIGHT,
        background: theme.palette.secondary.main,
        position: 'relative'
    },
    // header: {
    //     height: HEADER_HEIGHT
    // },
    // logoHeight: {
    //     height: 24,
    //     cursor: 'pointer'
    // },
    // hambergerIcon: {
    //     marginRight: 14
    // },
    // icon: {
    //     cursor: 'pointer',
    //     display: 'flex'
    // },
    // avatar: {
    //     cursor: 'pointer',
    //     backgroundColor: '#fff'
    // },
    // breadcrumbs: {
    //     marginLeft: 50,
    //     flex: 1,
    //     [theme.breakpoints.down('xs')]: {
    //         marginLeft: 0
    //     }
    // },
    menu: {
        cursor: 'pointer'
    },

    searchInput: {
        '& > div': {
            border: 'none'
        },
        '& path': {
            fill: `${theme.colors.greySuit} !important`
        },
        '& input::placeholder': {
            color: theme.colors.greySuit
        },
        '& input': {
            color: theme.colors.white
        }
    },
    // envLabel: {
    //     position: 'relative',
    //     marginLeft: 8,
    //     top: -6,
    //     background: ENV === STAGING ? '#E94C8B' : '#32BCF0',
    //     borderRadius: 18,
    //     color: theme.colors.white,
    //     fontWeight: 'bold',
    //     padding: `2px 6px`,
    //     fontSize: 9,
    //     textTransform: 'uppercase',

    //     [theme.breakpoints.down('md')]: {
    //         display: 'none'
    //     }
    // },
    listItem: {
        '& .textContent': {
            color: theme.colors.lightLavender,
            fontWeight: 500
        }
    },
    branchDropdown: {
        background: theme.colors.darkLavender,
        '& .input': {
            paddingLeft: 8,
            paddingRight: 8
        }
    },
    dropdownMenu: {
        maxHeight: '60vh',
        maxWidth: 400
    },
    // optionCreate: {
    //     paddingTop: POPUP_PADDING_TOP_BOTTOM,
    //     marginTop: POPUP_PADDING_TOP_BOTTOM,
    //     borderTop: `1px solid ${theme.colors.divider}`
    // },
    tooltipContent: {
        background: theme.colors.primaryText,
        color: theme.colors.white,
        width: 280,
        borderRadius: 6,
        '& p': {
            color: theme.colors.white
        },
        padding: theme.spacing(3, 4)
    },
    popper: {
        zIndex: 101,
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginTop: '-0.9em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '0 1em 1em 1em',
                borderColor: `transparent transparent ${theme.colors.primaryText} transparent`
            }
        },
        '&[x-placement*="top"] $arrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-0.9em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '1em 1em 0 1em',
                borderColor: `${theme.colors.primaryText} transparent transparent transparent`
            }
        },
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: '-0.9em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 1em 1em 0',
                borderColor: `transparent ${theme.colors.primaryText} transparent transparent`
            }
        },
        '&[x-placement*="left"] $arrow': {
            right: 0,
            marginRight: '-0.9em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 0 1em 1em',
                borderColor: `transparent transparent transparent ${theme.colors.primaryText}`
            }
        }
    },
    arrow: {
        position: 'absolute',
        fontSize: 7,
        width: '3em',
        height: '3em',
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: 0,
            height: 0,
            borderStyle: 'solid'
        }
    },
    // link: {
    //     textDecoration: 'none',
    //     '&:hover': {
    //         textDecoration: 'underline'
    //     }
    // },
    gridType: {
        marginLeft: theme.spacing(1),
        borderRadius: 4,
        padding: `2px 6px`,
        background: theme.colors.burntSlena,
        color: `${theme.colors.white} !important`,
        fontWeight: 500
    },
    popperSearchMenu: {
        '& > div': {
            paddingTop: 0,
            paddingBottom: 0
        }
    },
    highlight: {
        height: 32,
        width: 32,
        borderRadius: 4,
        background: theme.colors.dodgerBlue
    },
    freeTrialBanner: {
        borderRadius: 8
    }
}));

function Header({ isGridUI = false, onToggleDrawer, isShowToggle, isTablet }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isFilteringSorting = useIsFilteringSorting();
    const isFetchingDisabledColumnData = useIsFetchingDisabledColumnData();
    const isLoading = useGridUIIsLoading();
    const isImportLoading = useViewImportLoading();
    const user = useCurrentUserFullInfo();
    const canUseVersionControl = useCanVersionControl();
    const allUploadingFileCount = useAllUploadingFileCount();
    const isOpenFeedback = useIsOpenFeedback();

    const history = useHistory();
    const roles = useRole();

    const [openWhatNew, setOpenWhatNew] = React.useState(false);
    const [isOpenCreateBranchForm, setIsOpenCreateBranchForm] = React.useState(false);
    const helpMenuButtonRef = React.useRef();
    const popperRef = React.useRef();
    const { gridId, dbId, branchId } = useParams();
    const workspaceDetail = useSelectedWorkspace();
    const workspaceId = workspaceDetail?.id;
    const dbGridList = useGridsByDbId(dbId);
    const currentGrid = useGridDetail({ dbId, gridId });
    const branchOptions = useBranchesOptions({ dbId, gridId });
    const currentDatabase = useDatabaseByDbId(dbId);
    const pathname = history?.location?.pathname;

    const haveAccessToProject = React.useMemo(() => {
        return pathname.includes('/projects');
    }, [pathname]);

    const isSettingPage = React.useMemo(() => {
        return pathname.includes('/company-settings');
    }, [pathname]);
    const isTMPage = React.useMemo(() => {
        return pathname.includes('/localization-settings/') && pathname.includes('/tm');
    }, [pathname]);

    const isLocalesPage = pathname.includes('/localization-settings/') && pathname.includes('/locales');
    const isLQAPage = pathname.includes('/localization-settings/') && pathname.includes('/lqa');
    const isTBPage = pathname.includes('/localization-settings/') && pathname.includes('/tb');
    const [isOpenLimitModal, setIsOpenLimitModal] = React.useState(false);

    const jiraCreateTypesOptions = useJiraCreateTypeOptions();

    const classes = useStyles({ isGridUI });
    const theme = useTheme();
    const [switchGridConfirm, setSwitchGridConfirm] = React.useState(false);
    const [clickLogoConfirm, setClickGridLogoConfirm] = React.useState(false);
    const [clickProjectConfirm, setClickProjectConfirm] = React.useState(false);
    const [switchBranchConfirm, setSwitchBranchConfirm] = React.useState(false);
    const [selectedGridChange, setSelectedGridChange] = React.useState(null);
    const [selectedbranchChange, setSelectedbranchChange] = React.useState(null);
    const [helpPopupAnchorEl, setHelpPopupAnchorEl] = React.useState(false);
    const [selectedTemplateId, setSelectedTemplateId] = React.useState(null);
    const [searchAnchorEl, setSearchAnchorEl] = React.useState(null);
    const [searchValue, setSearchValue] = React.useState('');
    const currentAddonVersion = useInAppAddonVersion();
    const viewedAddonVersion = useAddonOpen();
    const hasNewAddon = currentAddonVersion !== viewedAddonVersion;
    const isShowTemplates = useIsShowTemplates();

    const isProTrial = useIsProTrial();
    const trialBackViewTime = useTrialBackViewTime();
    const isInRetrialPeriod = useIsRetrialPeriod() && isProTrial;

    const handleOpenFeedbackDialog = () => dispatch(appActions.setIsOpenFeedback(true));
    const handleCloseFeedbackDialog = () => dispatch(appActions.setIsOpenFeedback(false));

    const isShowToggleKeyboardShortCut = useIsShowToggleKeyboardShortCut();

    const handleOpenKeyboardShortcutModal = () => {
        dispatch(appActions.toggleKeyboardShortCut());
    };
    const handleCloseKeyboardShortcutModal = () => {
        dispatch(appActions.toggleKeyboardShortCut());
    };

    const [isOpenAddon, setIsOpenAddon] = React.useState(false);

    const handleCloseModal = React.useCallback(() => setIsOpenCreateBranchForm(false), []);

    const handleOpenAddon = React.useCallback(() => {
        if (hasNewAddon) {
            dispatch(
                authActions.setUserSettings({
                    settings: {
                        [USER_SETTINGS.OPEN_ADD_ON]: currentAddonVersion
                    },
                    successCallback: () => {},
                    errorCallback: () => {}
                })
            );
        }
        setIsOpenAddon(true);
    }, [dispatch, currentAddonVersion, hasNewAddon]);

    const closeFreeTrialBack = React.useCallback(() => {
        dispatch(
            authActions.setUserSettings({
                settings: {
                    [USER_SETTINGS.TRIAL_BACK_VIEW_TIME]: new Date().getTime()
                },
                successCallback: () => {},
                errorCallback: () => {}
            })
        );
    }, [dispatch]);

    const handleCloseAddon = React.useCallback(() => setIsOpenAddon(false), []);

    const handleOpenTemplates = React.useCallback(() => {
        dispatch(appActions.setShowTemplates(true));
    }, [dispatch]);

    const handleCloseTemplates = React.useCallback(() => {
        dispatch(appActions.setShowTemplates(false));
    }, [dispatch]);

    const handleOpenChooseWorkspace = React.useCallback(
        id => {
            setSelectedTemplateId(id);
            handleCloseTemplates();
        },
        [handleCloseTemplates]
    );

    const handleCloseChooseWorkspace = React.useCallback(() => setSelectedTemplateId(null), []);

    const handleOpenLimitModal = React.useCallback(() => setIsOpenLimitModal(true), []);

    const stopPropagation = React.useCallback(e => {
        e.preventDefault();
        e.stopPropagation();
    }, []);

    const handleCloseLimitModal = React.useCallback(
        e => {
            stopPropagation(e);
            setIsOpenLimitModal(false);
        },
        [stopPropagation]
    );

    const handleUpgrade = React.useCallback(() => {
        history.push(`/company-settings/billing/overview`);
    }, [history]);

    const handleHelpPopupClick = React.useCallback(
        event => {
            setHelpPopupAnchorEl(helpPopupAnchorEl ? null : event.currentTarget);
        },
        [helpPopupAnchorEl]
    );

    const handleHelpPopupClickAway = React.useCallback(() => {
        setHelpPopupAnchorEl(null);
    }, []);

    const handleHelpMenuTooltipClose = React.useCallback(() => {
        dispatch(appActions.closeHelpMenuTooltip());
    }, [dispatch]);

    useClickAwaitListener(popperRef, e => {
        handleHelpMenuTooltipClose();
    });

    React.useEffect(() => {
        if (!jiraCreateTypesOptions) {
            dispatch(
                appActions.fetchJiraCreateTypes({
                    successCallback: () => {
                        console.log('fetch jira issue success');
                    },
                    errorCallback: () => {
                        console.log('fetch jira issue failed');
                    }
                })
            );
        }
    }, [dispatch, jiraCreateTypesOptions]);

    React.useEffect(() => {
        dispatch(
            paymentActions.fetchAddonPlans({
                successCallback: () => {
                    console.log('fetchAddonPlans success');
                },
                errorCallback: () => {
                    console.log('fetchAddonPlans failed');
                }
            })
        );
    }, [dispatch]);

    const handleGridChange = React.useCallback(
        grid => {
            if (grid && grid?.id !== currentGrid?.id) {
                const errorCallback = () => {
                    history.push(
                        `/projects/${workspaceId}/databases/${dbId}/grids/${grid.id}/branches/${grid.id}/views/${grid?.defaultAccessViewId}`
                    );
                };
                dispatch(
                    gridActions.getGridLastView({
                        dbId,
                        gridId: grid.id,
                        errorCallback,
                        successCallback: responseData => {
                            const { dbId, gridId, viewId, branchId } = responseData;
                            if (!dbId || !gridId || !viewId || !branchId) {
                                errorCallback();
                                return;
                            }
                            history.push(
                                `/projects/${workspaceId}/databases/${dbId}/grids/${gridId}/branches/${branchId}/views/${viewId}`
                            );
                        }
                    })
                );

                dispatch(gridUIActions.resetGridLoadingState());
                dispatch(gridUIActions.resetAllUploadStatus());
                dispatch(gridUIActions.clearQuickFilterAndQuickSort());
                dispatch(gridUIActions.clearUserActive());
                dispatch(gridUIActions.resetDisabledAndPendingColumnIds());
                dispatch(gridUIActions.clearUndo());
                dispatch(gridUIActions.resetCellStatus());
                dispatch(gridUIActions.resetRecordHistory());
                setSwitchGridConfirm(false);
            }
        },
        [dbId, history, dispatch, workspaceId, currentGrid]
    );

    const handleGridChangeWithCheck = React.useCallback(
        grid => {
            setSelectedGridChange(grid);
            if (allUploadingFileCount > 0) {
                return setSwitchGridConfirm(true);
            }
            handleGridChange(grid);
        },
        [allUploadingFileCount, handleGridChange]
    );

    const handleBranchChange = React.useCallback(
        branch => {
            if (branch && branch?.id !== branchId) {
                history.push(
                    `/projects/${workspaceId}/databases/${dbId}/grids/${gridId}/branches/${branch.id}/views/${branch?.defaultAccessViewId}`
                );

                dispatch(gridUIActions.resetGridLoadingState());
                dispatch(gridUIActions.resetAllUploadStatus());
                dispatch(gridUIActions.clearQuickFilterAndQuickSort());
                dispatch(gridUIActions.resetDisabledAndPendingColumnIds());
                dispatch(gridUIActions.clearUndo());
                dispatch(gridUIActions.resetCellStatus());
                dispatch(gridUIActions.resetRecordHistory());
                setSwitchBranchConfirm(false);
            }
        },
        [workspaceId, dbId, gridId, dispatch, history, branchId]
    );

    const handleBranchChangeWithCheck = React.useCallback(
        branch => {
            setSelectedbranchChange(branch);
            if (allUploadingFileCount > 0) {
                return setSwitchBranchConfirm(true);
            }
            handleBranchChange(branch);
        },
        [allUploadingFileCount, handleBranchChange]
    );

    const CreateBranch = React.useCallback(
        ({ handleClickAway }) => {
            const handleClick = () => {
                handleClickAway();
                if (!canUseVersionControl) {
                    handleOpenLimitModal();
                    return;
                }
                setIsOpenCreateBranchForm(true);
            };
            return (
                <AccessControl view={roleConst.WORKSPACE_AUTHORITIES.MANAGE_BRANCH}>
                    <div
                        className={`pt-[${POPUP_PADDING_TOP_BOTTOM}px] mt-[${POPUP_PADDING_TOP_BOTTOM}px] border-t border-[#E9EAEF]`}
                        tr-dt="Open Create Branch Setting"
                    >
                        <ListItem
                            id="header-branch-add"
                            name={t('create_new_branch')}
                            icon={<ColorAddSVG color={theme.colors.lightLavender} />}
                            className={`${classes.listItem}`}
                            moreIcon={!canUseVersionControl ? <UpgradeSVG /> : undefined}
                            onClick={handleClick}
                        />
                    </div>
                </AccessControl>
            );
        },
        [theme.colors.lightLavender, classes, canUseVersionControl, handleOpenLimitModal, t]
    );

    const goToProjectList = React.useCallback(
        e => {
            history.push(`/projects/${workspaceId}`);
            setClickProjectConfirm(false);
        },
        [history, workspaceId]
    );

    const clickProjectCheck = React.useCallback(
        e => {
            e.preventDefault();
            if (allUploadingFileCount > 0) {
                return setClickProjectConfirm(true);
            }
            goToProjectList(e);
        },
        [allUploadingFileCount, goToProjectList]
    );

    const breadcrumbs = React.useMemo(() => {
        if (isShowToggle || isTablet) {
            return [];
        }

        // Company Settings breadcrumbs
        if (isSettingPage) {
            return [
                {
                    path: `/`,
                    name: t('breadcrumb_home')
                },
                {
                    name: t('breadcrumb_settings'),
                    disabled: true
                }
            ];
        }

        // TM breadcrumbs
        if (isTMPage) {
            return [
                {
                    path: `/`,
                    name: t('breadcrumb_home')
                },
                {
                    name: t('global_translation_memory'),
                    disabled: true
                }
            ];
        }

        // Locales breadcrumbs
        if (isLocalesPage) {
            return [
                {
                    path: `/`,
                    name: t('breadcrumb_home')
                },
                {
                    name: t('breadcrumb_locale'),
                    disabled: true
                }
            ];
        }

        //LQA breadcrumbs
        if (isLQAPage) {
            return [
                {
                    path: '/',
                    name: t('breadcrumb_home')
                },
                {
                    name: t('lqa_models'),
                    disabled: true
                }
            ];
        }

        //TB breadcrumbs
        if (isTBPage) {
            return [
                {
                    path: '/',
                    name: t('breadcrumb_home')
                },
                {
                    name: t('global_glossary'),
                    disabled: true
                }
            ];
        }

        const gridOptions = dbGridList?.map(grid => {
            return {
                ...grid,
                value: grid.id,
                label: (
                    <OverflowItem truncated={true} placement="right" title={grid.name}>
                        <div className="flex items-center flex-nowrap this-is">
                            <div className="truncate">{grid?.name}</div>
                            {SHOW_GRID_TYPES?.includes(grid?.type) && (
                                <div className="whitespace-nowrap">
                                    <span className={classes.gridType}>.{grid?.type}</span>
                                </div>
                            )}
                            {grid?.recordIdentifierType === RECORD_IDENTIFIER_TYPE.pathTagRecordId && (
                                <Tooltip title="The recordID in this Grid will be unique per each path">
                                    <div className="flex ml-2">
                                        <UniquePathtagRecordIdSVG />
                                    </div>
                                </Tooltip>
                            )}
                            {grid?.globalUniquePublicRecordId && (
                                <Tooltip title="Record IDs will be auto-generated and cannot be edited to ensure the uniqueness">
                                    <div className="flex ml-2">
                                        <GlobalUniqueRecordIdSVG />
                                    </div>
                                </Tooltip>
                            )}
                        </div>
                    </OverflowItem>
                ),
                icon: <GridIcon size="small" grid={grid} />
            };
        });

        // Grid breadcrumbs
        const breadcrumbs = [];
        if (currentGrid) {
            breadcrumbs.push({
                component: (
                    <Link
                        className={classNames('no-underline hover:underline')}
                        to={`/projects/${workspaceId}`}
                        onClick={e => clickProjectCheck(e)}
                    >
                        {workspaceDetail?.name}
                    </Link>
                )
            });

            breadcrumbs.push({
                parent: currentDatabase ? currentDatabase.name : null,
                name: currentGrid?.name,
                component: (
                    <DropdownMenu
                        id={`header-breadcrumbs-grid`}
                        value={gridId}
                        options={gridOptions}
                        onChange={handleGridChangeWithCheck}
                        color={themes.colors.white}
                        className={classes.branchDropdown}
                        menuClassName={classes.dropdownMenu}
                    />
                )
            });

            breadcrumbs.push({
                name: currentGrid?.name,
                component: (
                    <DropdownMenu
                        id={`header-breadcrumbs-branch`}
                        value={branchId}
                        options={branchOptions}
                        onChange={handleBranchChangeWithCheck}
                        color={themes.colors.white}
                        Control={CreateBranch}
                        className={classes.branchDropdown}
                        menuClassName={classes.dropdownMenu}
                    />
                )
            });
        }

        if (breadcrumbs.length > 0) {
            const latest = breadcrumbs[breadcrumbs.length - 1];
            latest.isLast = true;
            latest.path = null;
        }

        return breadcrumbs;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSettingPage, isTMPage, workspaceId, workspaceDetail, gridId, dbId, dbGridList, branchOptions]);

    const progressValue = React.useMemo(() => {
        return isLoading || isFilteringSorting || isImportLoading || isFetchingDisabledColumnData ? 'loading' : '';
    }, [isLoading, isFilteringSorting, isImportLoading, isFetchingDisabledColumnData]);

    const onBrandCreated = React.useCallback(
        newBranch => {
            // history.push(
            //     `/projects/${workspaceId}/databases/${dbId}/grids/${gridId}/branches/${newBranch.id}/views/${newBranch?.defaultAccessViewId}`
            // );
            dispatch(gridUIActions.resetRecordHistory());
        },
        [dispatch]
    );

    const useAvatar = React.useMemo(() => {
        return user.imageUrl;
    }, [user.imageUrl]);

    const TriggerAvatarRender = React.useCallback(
        ({ handleClick }) => (
            <Tooltip
                title={
                    <>
                        <p className="leading-normal">{t('your_account')}</p>
                        <p className={`leading-normal text-[#ffffff80]`}>{user?.email}</p>
                    </>
                }
            >
                <div className="p-3">
                    <Avatar
                        onClick={handleClick}
                        tr-dt="Open User Profile"
                        alt="avatar"
                        className="cursor-pointer bg-white"
                        src={getAvatarUrl(useAvatar)}
                    />
                </div>
            </Tooltip>
        ),
        [useAvatar, classes.avatar, user, theme, t]
    );

    const goToRoot = React.useCallback(() => {
        history.push('/');
        setClickGridLogoConfirm(false);
    }, [history]);

    const goToRootCheck = React.useCallback(() => {
        if (allUploadingFileCount > 0) {
            return setClickGridLogoConfirm(true);
        }
        goToRoot();
    }, [goToRoot, allUploadingFileCount]);

    const handleOpenSearchBox = React.useCallback(
        e => {
            if (!searchAnchorEl) {
                setSearchAnchorEl(e?.currentTarget);
            }
        },
        [searchAnchorEl]
    );

    const handleCloseSearchRecordBox = React.useCallback(e => {
        if (checkContainId(e, 'header-search')) return;
        setSearchAnchorEl(null);
    }, []);

    const handleWhatNew = React.useCallback(
        val => () => {
            sendManualTrack({
                type: val ? `[Gridly] Open what's new post list` : `[Gridly] Close what's new post list`
            });
            setOpenWhatNew(val);
            handleHelpPopupClickAway();
        },
        [handleHelpPopupClickAway]
    );

    return (
        <Paper className={classes.root} elevation={0}>
            <div className={classNames(`flex items-center justify-between flex-nowrap h-[${HEADER_HEIGHT}px]`)}>
                <div>
                    <div className="flex items-center flex-nowrap">
                        {isShowToggle && !isGridUI && (
                            <div id="header-hamberger-icon" className="mr-[14px]">
                                <HambergerMenuSVG
                                    color={theme.colors.white}
                                    className="cursor-pointer"
                                    onClick={onToggleDrawer}
                                    variant="contained"
                                />
                            </div>
                        )}
                        <div id="header-logo" onClick={goToRootCheck} className="h-[24px] cursor-pointer">
                            <LogoSVG className={classes.logo} />
                        </div>
                        {(ENV === STAGING || ENV === DEVELOPMENT || ENV === INTEGRATION) && (
                            <div
                                id="header-env"
                                item
                                className={classNames(
                                    `relative ml-2 top-[-6px] rounded-[18px] text-white font-bold px-[6px] py-[2px] text-[9px] uppercase max-md:hidden`,
                                    ENV === STAGING ? `bg-[#E94C8B]` : `bg-[#32BCF0]`
                                )}
                            >
                                <span>
                                    {ENV === STAGING && 'Staging'}
                                    {ENV === DEVELOPMENT && 'Dev'}
                                    {ENV === INTEGRATION && 'Integration'}
                                </span>
                            </div>
                        )}

                        <div id="header-breadcrumbs-container" className="ml-[50px] flex-1">
                            <BreadCrumbs breadcrumbs={breadcrumbs} color="white" />
                        </div>
                    </div>
                </div>

                {!isShowToggle && (
                    <div>
                        <div className="flex items-center flex-nowrap">
                            {haveAccessToProject && (
                                <AccessControl view={roleConst.SUPPORT_GLOBAL_SEARCH}>
                                    {({ isReadOnly }) => (
                                        <div className={classNames(classes.searchInput, 'p-3')}>
                                            {haveAccessToProject && !isGridUI && (
                                                <Search
                                                    onClick={handleOpenSearchBox}
                                                    onChange={e => setSearchValue(e?.target?.value)}
                                                    value={searchValue}
                                                    id="header-search"
                                                    placeholder={t('search_by_project')}
                                                    background={theme.colors.darkLavender}
                                                    width={256}
                                                />
                                            )}
                                        </div>
                                    )}
                                </AccessControl>
                            )}
                            <Tooltip title={t('global_help')}>
                                <div className="p-3" ref={helpMenuButtonRef} onClick={handleHelpPopupClick}>
                                    <HelpSVG className="flex cursor-pointer" />
                                </div>
                            </Tooltip>
                            <AccessControl view={roleConst.WORKSPACE_AUTHORITIES.MANAGE_GRID}>
                                <Tooltip title="Templates">
                                    <div
                                        className="p-3"
                                        id="header-template"
                                        tr-dt="Open Template"
                                        style={{ position: 'relative' }}
                                    >
                                        <TemplatesHeaderItem onClick={handleOpenTemplates} />
                                    </div>
                                </Tooltip>
                            </AccessControl>
                            {(roles?.[roleConst.COMPANY_AUTHORITIES.MANAGE_ADD_ON] === roleConst.FULL ||
                                roles?.[roleConst.COMPANY_AUTHORITIES.MANAGE_BILLING] === roleConst.FULL) && (
                                <Tooltip title={t('global_integrations')}>
                                    <div
                                        className="p-3"
                                        id="header-addon"
                                        tr-dt="Open Add-ons"
                                        onClick={handleOpenAddon}
                                    >
                                        <div
                                            className={classNames(
                                                hasNewAddon ? classes.highlight : ``,
                                                'flex items-center justify-center'
                                            )}
                                        >
                                            <AddonSVG
                                                className={classes.icon}
                                                color={hasNewAddon ? theme.colors.white : theme.colors.paleLavender}
                                            />
                                        </div>
                                    </div>
                                </Tooltip>
                            )}

                            <AccessControl view={roleConst.SUPPORT_NOTIFICATION}>
                                {({ isReadOnly }) => <NotificationCenter />}
                            </AccessControl>
                            <AccessControl view={roleConst.SUPPORT_GLOBAL_CHAT}>
                                {({ isReadOnly }) => (
                                    <Tooltip title={t('global_chat')}>
                                        <div className="p-3" id="header-chat" tr-dt="Open Chat">
                                            <ChatSVG className={classes.icon} />
                                        </div>
                                    </Tooltip>
                                )}
                            </AccessControl>
                            <AccessControl view={roleConst.SUPPORT_JIRA_FEEDBACK}>
                                {({ isReadOnly }) => (
                                    <div className="p-3 cursor-pointer" onClick={handleOpenFeedbackDialog}>
                                        <div className="flex items-center flex-nowrap gap-2">
                                            <div className="flex">
                                                <CommentsSVG
                                                    size={18}
                                                    color={theme.colors.paleLavender}
                                                    className={classes.icon}
                                                />
                                            </div>
                                            <p className="body1 text-[#A69FC4]">Feedback</p>
                                        </div>
                                    </div>
                                )}
                            </AccessControl>
                            <div id="header-user" className="p-0">
                                <MenuBase
                                    Trigger={TriggerAvatarRender}
                                    Content={({ setOpen }) => {
                                        return <UserMenu setOpen={setOpen} />;
                                    }}
                                    left={true}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {isShowToggle && (
                    <div id="header-user">
                        <MenuBase
                            Trigger={TriggerAvatarRender}
                            Content={({ setOpen }) => <UserMenu setOpen={setOpen} />}
                            left={true}
                        />
                    </div>
                )}
            </div>
            <Dialog open={isOpenAddon} maxWidth={false} onClose={handleCloseAddon}>
                <AddonList onClose={handleCloseAddon} />
            </Dialog>
            <Dialog id={'clone-grid-modal'} maxWidth={false} open={isOpenCreateBranchForm} onClose={handleCloseModal}>
                <CreateGridBranchForm onBrandCreated={onBrandCreated} onClose={handleCloseModal} />
            </Dialog>
            <LinearProgress value={progressValue} />
            <Dialog open={isOpenLimitModal} maxWidth={false} onClose={handleCloseLimitModal}>
                <LimitPopup
                    title={t('version_control')}
                    message={`Version control is only available on paid plans. Please upgrade to branch the grid and use version control functionality.`}
                    onCancel={handleCloseLimitModal}
                    onUpgrade={handleUpgrade}
                    onClose={handleCloseLimitModal}
                />
            </Dialog>
            <Dialog open={isOpenFeedback} onClose={handleCloseFeedbackDialog}>
                <FeedbackForm onClose={handleCloseFeedbackDialog} />
            </Dialog>
            <Dialog open={switchGridConfirm} onClose={handleCloseFeedbackDialog}>
                <ConfirmBox
                    title="Exit Grid"
                    body={
                        <div className="flex flex-col">
                            <p className="body2">Do you want to exit this grid?</p>
                            <p className="body2">Exit the grid might cause uploading interruption</p>
                        </div>
                    }
                    handleCancel={() => setSwitchGridConfirm(false)}
                    onClose={() => setSwitchGridConfirm(false)}
                    handleAgreed={() => handleGridChange(selectedGridChange)}
                    agreeLabel="Yes"
                />
            </Dialog>
            <Dialog open={clickLogoConfirm} onClose={handleCloseFeedbackDialog}>
                <ConfirmBox
                    title="Exit Grid"
                    body={
                        <div className="flex flex-col">
                            <p className="body2">Do you want to exit this grid?</p>
                            <p className="body2">Exit the grid might cause uploading interruption</p>
                        </div>
                    }
                    handleCancel={() => setClickGridLogoConfirm(false)}
                    onClose={() => setClickGridLogoConfirm(false)}
                    handleAgreed={goToRoot}
                    agreeLabel="Yes"
                />
            </Dialog>
            <Dialog open={clickProjectConfirm} onClose={handleCloseFeedbackDialog}>
                <ConfirmBox
                    title="Exit Grid"
                    body={
                        <div className="flex flex-col">
                            <p className="body2">Do you want to exit this grid?</p>
                            <p className="body2">Exit the grid might cause uploading interruption</p>
                        </div>
                    }
                    handleCancel={() => setClickProjectConfirm(false)}
                    onClose={() => setClickProjectConfirm(false)}
                    handleAgreed={goToProjectList}
                    agreeLabel="Yes"
                />
            </Dialog>
            <Dialog open={switchBranchConfirm} onClose={handleCloseFeedbackDialog}>
                <ConfirmBox
                    title="Exit Grid"
                    body={
                        <div className="flex flex-col">
                            <p className="body2">Do you want to exit this grid?</p>
                            <p className="body2">Exit the grid might cause uploading interruption</p>
                        </div>
                    }
                    handleCancel={() => setSwitchBranchConfirm(false)}
                    onClose={() => setSwitchBranchConfirm(false)}
                    handleAgreed={() => handleBranchChange(selectedbranchChange)}
                    agreeLabel="Yes"
                />
            </Dialog>
            {helpPopupAnchorEl && (
                <PopperMenu
                    placement={'bottom-start'}
                    anchorEl={helpPopupAnchorEl}
                    handleClickAway={handleHelpPopupClickAway}
                >
                    <HelpMenuPopup
                        isGridUI={isGridUI}
                        onClose={handleHelpPopupClickAway}
                        onKeyboardShortcutClick={handleOpenKeyboardShortcutModal}
                        openWhatNew={handleWhatNew(true)}
                    />
                </PopperMenu>
            )}
            <Dialog maxWidth={false} open={isShowToggleKeyboardShortCut} onClose={handleCloseKeyboardShortcutModal}>
                <GridlyKeyBoard onClose={handleCloseKeyboardShortcutModal} />
            </Dialog>

            <PreloadImages paths={[AddonBanner, EggSearchGif]} />

            <AccessControl view={roleConst.WORKSPACE_AUTHORITIES.MANAGE_GRID}>
                <Dialog maxWidth={false} open={isShowTemplates} onClose={handleCloseTemplates}>
                    <Templates onOpenChoosingWorkspace={handleOpenChooseWorkspace} onClose={handleCloseTemplates} />
                </Dialog>
            </AccessControl>
            <Dialog maxWidth={false} open={!!selectedTemplateId} onClose={handleCloseChooseWorkspace}>
                <ChooseWorkspaceDatabase selectedTemplateId={selectedTemplateId} onClose={handleCloseChooseWorkspace} />
            </Dialog>

            {!trialBackViewTime && isInRetrialPeriod && (
                <Dialog open={true} classes={{ paper: classes.freeTrialBanner }}>
                    <FreeTrialBack onClose={closeFreeTrialBack} />
                </Dialog>
            )}

            {haveAccessToProject && searchAnchorEl && (
                <PopperMenu
                    id={'popper-searchBox-global'}
                    placement={'bottom'}
                    anchorEl={searchAnchorEl}
                    handleClickAway={handleCloseSearchRecordBox}
                    className={classes.popperSearchMenu}
                >
                    <SearchGlobalBox
                        onClose={handleCloseSearchRecordBox}
                        value={searchValue}
                        setSearchValue={setSearchValue}
                    />
                </PopperMenu>
            )}
            <WhatNewDrawer open={openWhatNew} onClose={handleWhatNew(false)} />
            {!isExternal && <WhatNewDialog />}
        </Paper>
    );
}

Header.propTypes = {
    isGridUI: PropTypes.bool
};

export default React.memo(Header);
